var map = {
	"./Affiliate-white.svg": 518,
	"./about-us.png": 404,
	"./about-us.svg": 519,
	"./affiliate.png": 405,
	"./affiliate.webp": 520,
	"./arrow-down.png": 406,
	"./bet_pnl.png": 407,
	"./blogs.png": 408,
	"./change_no.png": 409,
	"./faqs.png": 410,
	"./faqs.svg": 521,
	"./favorites.png": 411,
	"./feedback.png": 258,
	"./help.svg": 522,
	"./loyalty.png": 412,
	"./loyalty.svg": 523,
	"./market.png": 413,
	"./market.svg": 524,
	"./news.png": 414,
	"./news.svg": 525,
	"./notification.png": 415,
	"./online-betting-app.svg": 526,
	"./open_bets.png": 416,
	"./privacy.png": 417,
	"./privacy.svg": 527,
	"./profile.png": 418,
	"./promotions.png": 419,
	"./promotions.svg": 528,
	"./reset_password.png": 420,
	"./rules.png": 421,
	"./settings.png": 422,
	"./terms-and-conditions.png": 423,
	"./terms-and-conditions.svg": 529,
	"./transactions.png": 424,
	"./wallet.png": 425
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 294;